import { Paginated } from "../../../types/api";
import { SelectableOption } from "../../../types/options";
import { api } from "../index";

const extendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTitleOptions: builder.query<SelectableOption[], void>({
      query: () => `/title_options/`,
      transformResponse: (response: Paginated<SelectableOption>) =>
        response.results,
    }),
  }),
});

export const { useGetTitleOptionsQuery } = extendedApi;
